import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import PropTypes from 'prop-types';

// components
import { FormattedMessage } from 'react-intl';
import { SbSharedSearchSuggestions } from '../SbSharedSearchSuggestions/SbSharedSearchSuggestions';

// styles
import styles from './SbRespNullSearchResultsHeader.scss';

export const SbRespNullSearchResultsHeaderComponent = props => {
    const { searchTerm } = props;

    return (
        <div className={styles.container}>
            <div className={styles.results}>
                <FormattedMessage
                    id="sb.SbRespNullSearchResultsHeader.zeroResults"
                    defaultMessage={`0 results for "{searchTerm}"`}
                    values={{ searchTerm }}
                />
            </div>
            <SbSharedSearchSuggestions
                className={styles.searchSuggestions}
                searchBrowse={props.searchBrowse}
            />
        </div>
    );
};

SbRespNullSearchResultsHeaderComponent.propTypes = {
    searchTerm: PropTypes.string,
    searchBrowse: PropTypes.object.isRequired,
};

export const SbRespNullSearchResultsHeader = createFragmentContainer(
    SbRespNullSearchResultsHeaderComponent,
    {
        searchBrowse: graphql`
            fragment SbRespNullSearchResultsHeader_searchBrowse on SearchBrowseQueryConnection {
                ...SbSharedSearchSuggestions_searchBrowse
            }
        `,
    }
);
